export const TWITTER_ACTION_ICON_PATHS: string[] = [
  'images/socialmedia/comment-icon-twitter.svg',
  'images/socialmedia/repost-icon-twitter.svg',
  'images/socialmedia/like-icon-twitter.svg',
  'images/socialmedia/views-icon-twitter.svg',
  'images/socialmedia/share-icon-twitter.svg',
];
